import { cn } from '@/lib/utils';
import type { RateDisplay } from '../hooks/useMessageRate';

interface Props {
  paused: boolean;
  total: number;
  rate: RateDisplay;
  qos: number;
  size: string;
}

function Stat({
  value,
  label,
  testId,
}: { value: string | number; label: string; testId?: string }) {
  return (
    <div className="flex flex-col gap-[1px]">
      <span
        className="font-mono text-[0.923em] font-bold text-(--color-text2)"
        data-testid={testId}
      >
        {value}
      </span>
      <span className="font-sans text-[0.692em] font-bold uppercase tracking-[0.4px] text-(--color-text3)">
        {label}
      </span>
    </div>
  );
}

export function LiveStatusBar({ paused, total, rate, qos, size }: Props) {
  return (
    <div
      className={cn(
        'flex items-center gap-2.5 border-b border-(--color-border) bg-(--color-surface) px-2.5 py-1 font-sans text-[0.846em] text-(--color-text3)',
      )}
    >
      <span
        className={cn(
          'h-[5px] w-[5px] shrink-0 rounded-full',
          paused
            ? 'bg-(--color-amber)'
            : 'bg-(--color-green) animate-[pulse-dot_1.5s_ease-in-out_infinite]',
        )}
      />
      <span className="text-[0.615em] font-bold" data-testid="ds-live-label">
        {paused ? 'Paused' : 'Live'}
      </span>
      <span className="h-3.5 w-px bg-(--color-border)" />
      <Stat value={total} label="msgs" testId="ds-total" />
      <span className="h-3.5 w-px bg-(--color-border)" />
      <Stat value={rate.value} label={rate.unit} />
      <span className="h-3.5 w-px bg-(--color-border)" />
      <Stat value={`QoS ${qos}`} label="quality" />
      <span className="h-3.5 w-px bg-(--color-border)" />
      <Stat value={size} label="size" />
    </div>
  );
}
